import React, { useEffect } from 'react';
import { useLocation, Navigate } from 'react-router-dom';
import Section from '../components/ui/Section';
import Heading from '../components/ui/Heading';

const LeaderProfilePage = () => {
  const location = useLocation();


  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // Check if leader data is passed through navigation state
  const leader = location.state?.leaderData;

  // If no leader data is found, redirect back to about page
  if (!leader) {
    return <Navigate to="/about" replace />;
  }

  return (
    <Section className="py-16">
      <div className="max-w-5xl mx-auto">
        {/* Profile Block with Image, Name, and Role */}
        <div className="bg-gray-100 rounded-lg p-8 mb-8 flex flex-col md:flex-row items-center">
          <div className="w-full max-w-xs rounded-lg overflow-hidden shadow-lg mb-4 md:mb-0 md:mr-8">
            <img 
              src={leader.image} 
              alt={leader.name} 
              className="w-full h-auto object-cover"
            />
          </div>
          <div className="text-center md:text-left">
            <Heading level={2} className="text-xl font-medium text-gray-800 mb-2">
              {leader.name}
            </Heading>
            <p className="text-lg text-gray-800">
              {leader.position || leader.role}
            </p>
          </div>
        </div>

        {/* Biography Section */}
        <div className="text-lg max-w-3xl mx-auto text-gray-700">
          <p>{leader.bio}</p>
        </div>
      </div>
    </Section>
  );
};

export default LeaderProfilePage;